import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { BULLET_POINTS } from './constants';

export function Header() {
	return (
		<>
			<Heading as="h2" size="h4" id="update-supporters-title" mb="16">
				Turn your signers into supporters
			</Heading>
			<Text size="small" sx={{ lineHeight: '22px' }}>
				Engage your supporters by sending updates that will be emailed to all petition signers and posted on your
				petition page. Here are some ideas:
			</Text>
			<Flex sx={{ flexDirection: 'column', gap: 16 }} mt="16">
				{BULLET_POINTS.map(({ Icon, text, size }, index) => (
					<Flex key={`bullet-point-${index + 1}`} sx={{ alignItems: 'flex-start', gap: 8 }}>
						<Icon size={size} className="text-icon-brand" />
						<Text size="small" sx={{ lineHeight: '22px' }}>
							{text}
						</Text>
					</Flex>
				))}
			</Flex>
		</>
	);
}
